import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {addCustomerArticleFavorite, removeCustomerArticleFavorite} from '@store/actions/user.action';
import {Subject, takeUntil} from 'rxjs';
import {faHeart as faHeartSolid} from "@fortawesome/free-solid-svg-icons";
import {faHeart as faHeartRegular} from "@fortawesome/free-regular-svg-icons";
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {UserService} from "@iw-shop/user/services/user.service";

@Component({
    selector: 'iw-shop-article-favorite-button',
    templateUrl: './article-favorite-button.component.html',
    standalone: false,
    styleUrls: ['./article-favorite-button.component.scss']
})
export class ArticleFavoriteButtonComponent implements OnInit {

  @Input() articleNumber: string = '';

  destroy$: Subject<boolean> = new Subject<boolean>();

  customerId?: string;
  favorite = false;

  constructor(private store: Store<AppState>, private userService: UserService) {

  }

  hasUserAccess(){
      return this.userService.hasLoggedInUserAccess({type: 'favorites', customerId: this.customerId ?? ''});
  }

  ngOnInit(): void {
    this.store.select(getSelectedCustomer)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(
      user => {
        this.customerId = undefined;
        if (user &&
          user.id) {
          this.customerId = user.id;
        }

        let favorites = user?.favoritesList?.filter(articleNumber => articleNumber == this.articleNumber);

        if (favorites &&
          favorites.length > 0) {
          this.favorite = true;
        } else {
          this.favorite = false;
        }
      }
    )
  }

  toggleFavorite() {
    this.favorite = !this.favorite;
    if (this.customerId) {
      if (this.favorite) {
        this.store.dispatch(addCustomerArticleFavorite({
          customerId: this.customerId,
          articleNumber: this.articleNumber
        }))
      } else {
        if (confirm('Möchten Sie den Artikel als Favoriten entfernen?') == true) {
          this.store.dispatch(removeCustomerArticleFavorite({
            customerId: this.customerId,
            articleNumber: this.articleNumber
          }))
        } else {
          this.favorite = !this.favorite;
        }

      }

    }
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

    protected readonly faHeartSolid = faHeartSolid;
    protected readonly faHeartRegular = faHeartRegular;
}
